export default "__VITE_ASSET__Cuw$F0dS__"